import React from 'react';
import { RoutineExecution } from './views/RoutinesView/RoutineExecution';
import { useRoutineSessionStore } from '../stores/routineSessionStore';
import { useRoutineStore } from '../stores/routineStore';

/**
 * Globally-mounted host for the active routine run. Rendered from Header (which
 * is always mounted) so the run survives page navigation. When minimized it is
 * kept mounted but `hidden` (display:none) — the timer's React state and
 * intervals keep running, and the header widget mirrors them — instead of being
 * unmounted, which would lose the run.
 */
export function RoutineSessionManager() {
  const activeRoutineId = useRoutineSessionStore(s => s.activeRoutineId);
  const expanded = useRoutineSessionStore(s => s.expanded);
  const stop = useRoutineSessionStore(s => s.stop);
  const routine = useRoutineStore(s =>
    activeRoutineId ? s.routines.find(r => r.id === activeRoutineId) ?? null : null
  );

  if (!activeRoutineId || !routine) return null;

  return (
    <div className={`fixed inset-0 z-50 overflow-y-auto bg-background ${expanded ? '' : 'hidden'}`}>
      <div className="px-4 pt-4 pb-8 lg:px-6 lg:pt-6 safe-area-pt">
        <RoutineExecution routine={routine} onClose={stop} />
      </div>
    </div>
  );
}
